import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#0079C2",
      d: "M23.02 10.431 1.914.134A1.33 1.33 0 0 0 0 1.331v.038q0 .269.065.53L2.09 9.996a.545.545 0 0 0 .47.41l8.899.989a.61.61 0 0 1 0 1.21l-8.9.99a.545.545 0 0 0-.469.41L.065 22.102q-.065.26-.065.529v.038a1.33 1.33 0 0 0 1.913 1.196L23.02 13.569a1.746 1.746 0 0 0 0-3.138"
    }, null, -1)
  ]))]))
}
export default { render: render }